import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeckListComponent } from './deck-list/deck-list.component';
import { AuthGuard } from '../auth/auth.guard';
import { DeckViewComponent } from './deck-view/deck-view.component';
import { PublicDeckViewComponent } from './public-deck-view/public-deck-view.component';
import { PublicDecksComponent } from './public-decks/public-decks.component';

const routes: Routes = [
    {
        path: '',
        component: DeckListComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'public',
        component: PublicDecksComponent
    },
    {
        path: 'share',
        redirectTo: 'public'
    },
    {
        path: ':id',
        component: DeckViewComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'share/:id',
        component: PublicDeckViewComponent,
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DeckRoutingModule {}
